// Import utilities
const {
	isDefined
} = _uo.utility;

// Import utilities
import { getConditionPostData } from './';

/**
 * Checks whether a condition has its fields already defined
 * This will be used to determine if we should do an AJAX call to get them
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The unique code of the integration
 * @param {String} options.conditionCode   The unique code of the condition
 * @return {Boolean}                       TRUE if it has fields
 */
const conditionPostDataHasFields = ( { integrationCode, conditionCode } ) => {
	// Get the condition post data
	const conditionPostData = getConditionPostData( { integrationCode, conditionCode } );

	return isDefined( conditionPostData.fields );
}

export default conditionPostDataHasFields;
